import CopyButton from './CopyButton';

interface Props {
  url: string;
  size?: 'small' | 'large';
}

export default function ShareUrl(props: Props) {
  const { url, size = 'large' } = props;
  return (
    <div
      className={`relative inline-flex items-center rounded-lg bg-grey7 px-1 ${
        size === 'large' ? 'h5' : 'h-4'
      }`}
    >
      <a
        href={url}
        target="_blank"
        className="max-w-18 truncate text-14 font-bold text-dark hover:underline"
        title={url}
        rel="noreferrer"
      >
        {url.split('//')[1]}
      </a>
      <div className="ml-0.5 h-2.25 w-2.25">
        <CopyButton
          value={url}
          className="transition-fast hover:scale-110"
          tooltipPlacement="bottom"
        />
      </div>
    </div>
  );
}
